import { createStore, createEvent } from 'effector'
import { ServerToClientCallMessage } from 'features/call/call-proto-generated'

class CallWsStateService {
  readonly $initialConnectTime = createStore<number>(0)
  readonly doSetInitialConnectTime = createEvent<number>()

  readonly $callId = createStore<string | null>(null)
  readonly $isForceResults = createStore<boolean>(false)
  readonly callStarted = createEvent<string>()
  readonly showResults = createEvent<void>()

  readonly $callEndReceived = createStore<boolean>(false)
  readonly callEndReceived = createEvent<void>()

  readonly gotWebSocketMessage = createEvent<ServerToClientCallMessage>()

  constructor() {
    this.$initialConnectTime.on(this.doSetInitialConnectTime, (_, v) => v)

    this.$callId.on([this.callStarted, this.showResults], (_, v) => v ?? null)

    this.$isForceResults.on(this.showResults, () => true)

    this.$callEndReceived.on(this.callEndReceived, () => true)
  }
}

export const callWsStateService = new CallWsStateService()
